<template>
    <div class="header container">
      <div class="header-logo">
        <div class="logo" @click="getLogo">
         <h1>
          <img src="../../assets/img/logo.png" alt="">
         </h1>
        </div>
        <!-- <div class="company-name">
          <h1>鹏沣智控</h1>
        </div> -->
      </div>
      <div class="header-right">
        <div class="header-right-list">
         <drop-down></drop-down>
        </div>
        <!-- <div class="header-right-search">
          <a-input size="large" placeholder="输入搜索内容" :maxLength="6"/>
          <img src="../../assets/img/search.png" alt="">
        </div> -->
      </div>
      <div class="changeLang">
        <div :class="language=='zh'?'zh active':'zh'" @click="setLanguage('zh')">中</div>
        <div :class="language=='en'?'en active':'en'" @click="setLanguage('en')">EN</div>
      </div>
    </div>
</template>
<script>
import DropDown from './DropDown.vue';
export default {
  name: 'HeaderView',
  components: {
    DropDown
  },
  data(){
    return {
      language:"zh"
    }
  },
  methods:{
    setLanguage(val){
      this.language = val
      // 切换语言
      this.$i18n.locale = this.language
      console.log(this.$t('language.zh'),"this.$t('language.zh')");
    },
    getLogo(){
      this.$router.push('/home')
    }
  }
}
</script>
<style scoped lang="scss">
  // 头部
  .header{
    position: relative;
    height: 1.25rem;
    background: #FFFFFF;
    // background: pink;
    display: flex;
    justify-content: space-between;
    .header-logo{
      // border: 1px sienna solid;
      flex: 1;
      .logo{
        width: 2.85rem;
        height:.65rem ;
        float: left;
        // margin-top: .2375rem;
        line-height: 1.25rem;
        margin: auto 0;
        img{
        
          width: 100%;
          height: 100%;
        }
        
      }
      
      // .company-name{
      //   float: left;
      //   h1{
      //     width: 100%;
      //     font-family: STLiti, STLiti;
      //     font-weight: 400;
      //     font-size: $font-size36;
      //     color: #222222;
      //     line-height:1.25rem;
      //     text-align: left;
         
      //   }
      // }
    }
    .header-logo:hover{
        cursor: pointer;
      }
    .header-right{
      flex: 3;
      // border: 1px sienna solid;
      .header-right-list{
        float: right;
       
      }
      // .header-right-search{
      //   position: relative;
      //   float: left;
      //   margin: .4125rem 0 0 .475rem;
      //   width: 1.9125rem;
      //   height: .425rem;
      //   background: #F1F1F1;
      //   box-shadow: 0px .125rem .125rem 0px rgba(0,0,0,0.03);
      //   border-radius: .625rem .625rem .625rem .625rem;
      //   .ant-input-lg{
      //     width: 1.9125rem;
      //     height: .425rem;
      //     box-shadow: 0px .125rem .125rem 0px rgba(0,0,0,0.03);
      //     border-radius: .625rem .625rem .625rem .625rem;
      //     text-indent: .25rem;
      //     font-size: .2rem;
      //   }
      //   img{
      //     position: absolute;
      //     left: .1375rem;
      //     top: 50%;
      //     margin-top:-0.1125rem ;
      //     width: .225rem;
      //     height: .225rem;
      //   }
      // }
    }
    .changeLang{
      position: absolute;
      top: .4125rem;
      right: -2rem;
      // right: 0;
      width: 1.35rem;
      height: .4375rem;
      border: .0125rem solid #666666;
      border-radius: .625rem .625rem .625rem .625rem;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: $font-size20;
      color: #222222;
      line-height: .4375rem;
      text-align: center;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      box-sizing: border-box;
      div{
        width: 50%;
        color: #222222;
      }
      .active{
        width: 80%;
        background: $bg-blue;
        border-radius: .625rem .625rem .625rem .625rem;
        color: #FFFFFF;
      }
      
    }
  }
</style>